// extracted by mini-css-extract-plugin
export default {"container":"container__F7fKx","btn":"btn__VHpUi","prev":"prev__SXDdN","next":"next__SWmcX","carousel":"carousel__wlz6x","image":"image__yqxjs","image-box":"image-box__gbhbW"};